import Select from '../vuetify/selects/Select'
import Events from '../../events'

export default {
    mixins: [Select],
    props: {
        dataUrl: String,
        timeLapse: {
            type: Number,
            default: 3000
        },
        minChars: {
            type: [String, Number],
            default: 3
        },
        dataParams: {
            type: [Function, Object, Boolean],
            default: false
        },
        dataPost: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: Boolean,
            default: true
        },
        loadOnce: {
            type: Boolean,
            default: false
        },
        manualInputEventId: {
            type: String,
            default: 'autocomplete-input'
        }
    },
    data() {
        return {
            lastSearchString: '',
            lastSearchTime: -1,
            itemsBuffer: [],
            loading: false
        }
    },
    computed: {
        filteredItems() {
            const items = this.autocomplete && this.searchValue
                ? this.filterSearch()
                : this.itemsBuffer
            return !this.auto ? items.slice(0, this.lastItem) : items
        },
        selectedItems() {
            if (this.inputValue === null) return []
            return this.itemsBuffer.filter(i => {
                if (!this.multiple) {
                    return this.getValue(i) === this.getValue(this.inputValue)
                } else {
                    return this.inputValue.find(j => this.getValue(j) === this.getValue(i))
                }
            })
        }
    },
    watch: {
        searchValue: function (newValue) { this.search(); }
    },
    methods: {
        search: function (firstLoad = false) {
            if (this.loadOnce && !firstLoad) return false;
            // Check timelapse, string length and if it has changed
            let time = Date.now();
            if (!this.loadOnce && !this.value) {
                if (time < this.lastSearchTime + this.timeLapse) return false;
                if (typeof this.searchValue !== 'string') return false;
                if (this.searchValue.length < this.minChars) return false;
                if (this.searchValue == this.lastSearchString) return false;
            }
            // Get data from the data-url
            let options = { params: {} };
            options.params[this.itemText] = this.searchValue;
            if (this.dataParams != false) {
                let dataParams = this.dataParams;
                if (typeof dataParams == 'function') { dataParams = dataParams() };
                Object.assign(options.params, dataParams);
            }
            if (this.value && !this.searchValue) {
                options.params[this.itemValue] = this.value;
            }
            let httpMethod = this.dataPost ? 'post' : 'get';
            if (httpMethod == 'post') options = options.params;
            this.loading = true;
            this.$http[httpMethod](this.dataUrl, options).then(response => {
                let items = response.body;
                if (typeof items == 'object') { items = Object.values(items); }
                this.itemsBuffer = items;
                this.loading = false;
            }, response => {
                console.log(response);
            });
            this.lastSearchTime = time;
            this.lastSearchString = this.searchValue;            
        },
        filterSearch() {
            // Overwrites vuetify's autocomplete.js to use itemsBuffer instead of items
            // (items is a const prop and props must not be changed)
            return this.itemsBuffer.filter(i => {
                const text = this.getText(i);
                if (typeof text === 'undefined') return false;
                var normalize = text => text.toLowerCase().removeAccents();
                return normalize(text).indexOf(normalize(this.searchValue)) !== -1;
            })
        },
        genPulseLoader() {
            return this.$createElement('v-subheader', { class: 'text-xs-center' },
                [this.$createElement('pulse-loader', {
                    props: { loading: true, size: '12px', color: 'teal' },
                    style: 'margin:auto' })])
        },
        genList () {
            const children = this.filteredItems.map(o => {
                if (o.header) return this.genHeader(o)
                if (o.divider) return this.genDivider(o)
                else return this.genTile(o)
            })
            if (this.loading) children.splice(0, 0, this.genPulseLoader());
            if (!children.length) {
                children.push(this.genTile(this.noDataText, true))
            }        
            return this.$createElement('v-card', [
                this.$createElement('v-list', {
                ref: 'list'
                }, children)
            ])
        }        
    },
    created: function () {
        this.$on('input', function(value) {            
            let name = ''
            for (let key in this.itemsBuffer) {
                let item = this.itemsBuffer[key]
                if (item[this.itemValue] == value) {
                    name = item[this.itemText]
                    break
                }
            }
            Events.$emit('inputText', name)
        })
        var that = this        
        Events.$on(this.manualInputEventId, function(item) {            
            that.inputValue = item[that.itemValue]
            that.itemsBuffer = [item]
        })
        
        if (this.loadOnce || this.value) { this.search(true) }
    }
}


// WEBPACK FOOTER //
// ./src/components/forms/AutoComplete.js